export enum CharageableDisposalType {
  IncidentalCostOfDisposal = 1,
  CostOfAcquistion = 2,
  CostOfEnhancement = 3,
}
